
import { defineComponent } from 'vue'
import { iCategory } from './../../RolesManagement'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import domainCategoryTabDescriptor from './DomainCategoryTabDescriptor.json'

export default defineComponent({
    name: 'domain-category-tab',
    components: {
        Card,
        Column,
        DataTable
    },
    props: {
        title: String,
        categoryList: Array,
        selected: Array
    },
    emits: ['changed'],
    data() {
        return {
            domainCategoryTabDescriptor,
            selectedCategories: [] as iCategory[]
        }
    },
    watch: {
        selected() {
            this.selectedCategories = this.selected as iCategory[]
        },
        selectedCategories(newCategories: iCategory[]): void {
            if (newCategories === this.selectedCategories) {
                this.setDirty()
            }
        }
    },
    created() {
        this.selectedCategories = this.selected as iCategory[]
    },
    methods: {
        setDirty() {
            this.$emit('changed', this.selectedCategories)
        }
    }
})
